import React from 'react';
import styled from 'styled-components/macro';

const StyledSectionTitle = styled.div`
  color: black;
  font-family: miller-display, serif;
  font-weight: 700;
  font-style: normal;
  font-size: 33px;
  padding: 0 16px;
  margin-bottom: ${props =>
    props.marginBottom === 'default' ? '24px' : props.marginBottom};
`;

const SectionTitle = props => {
  return <StyledSectionTitle marginBottom={props.titleMarginBottom}>{props.sectionTitle}</StyledSectionTitle>;
};

export default SectionTitle;
